import React from 'react'
import styled from 'styled-components'

interface PreviewProps {
  src?: string
  alt?: string
}

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  position: relative;
  border-radius: 6px 0px 0px 6px;
  width: 148px;
  overflow: hidden;

  ${({ theme }) => theme.mediaQueries.lg} {
    width: 100%;
    border-radius: 6px 6px 0px 0px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    border-radius: 6px 0px 0px 6px;
  }
`

const Preview: React.FC<PreviewProps> = ({ src, alt }) => (
  <Container>{src && <img width={600} src={src} alt={alt} style={{ height: '100%' }} />}</Container>
)

export default Preview
